<template>
  <fieldset>
    <legend class="label label--small leading-loose mb-6">
      {{ title }}
    </legend>
    <div class="filters-column__radio">
      <template v-for="option in prettyOptions">
        <input
          :id="option.option_id"
          :key="option.option_id"
          type="radio"
          :value="option.option_id"
          :checked="isSelected(option)"
          class="input-filter-radio"
          @change="handleSelect(option)"
        />
        <label :key="option.title" :for="option.option_id">
          {{ option.title }}
          <button
            :class="[
              isSelected(option) ? '' : 'hidden',
              'button--filters-clear',
            ]"
            @click="handleClose"
          >
            <span>
              <svg class="icon icon-close" aria-hidden="true" focusable="false">
                <use xlink:href="#icon-close" />
              </svg>
            </span>
          </button>
          <span class="block font-light mt-2 md:mt-0">{{ option.desc }}</span>
        </label>
      </template>
    </div>
  </fieldset>
</template>
<script>
export default {
  props: ['options', 'optionsMap', 'title', 'selectedScale'],
  computed: {
    prettyOptions() {
      return this.options.map(({ option, option_id, field_id }, ind) => {
        const title = option === 'mural' ? 'Mural' : 'Single Panel';
        const desc = this.optionsMap[option];

        return {
          title,
          desc,
          option_id,
          field_id,
          option,
        };
      });
    },
  },
  methods: {
    handleClose(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.$emit('close', {});
    },
    handleSelect(data) {
      this.$emit('select', data);
    },
    isSelected(opt) {
      return opt.option_id === this.selectedScale.option_id;
    },
  },
};
</script>
